/**
 * File: pline-filter.js
 * Description: Filter UI for the Pictureline website that isn't using Boosted
 * Author: Dylan Smith (@ayodyln)
 */

// Collection Info
const collectionMetaInfo = window.collectionMeta || {};
const collection = window.collection || [];
const collectionTags = window.collectionTags || [];
const collectionTypes = window.collection_types || [];

//? Price Range Slider
// Price Slider Elements
const rangeValue = document.querySelectorAll(".slider-container .price-slider");
const priceInputs = document.querySelectorAll(
  '.price-input input[type="number"]'
);
const rangeInputs = document.querySelectorAll(
  '.range-input input[type="range"]'
);

// Set Price Gap
let priceGap = 50;

// Initialization of Price Range Slider ~ From Collection Page in Window Object
const min = Math.min(...collection.map((item) => item.price)) / 100;
const max = Math.max(...collection.map((item) => item.price)) / 100;

console.log(rangeInputs);

// Update range slider positions based on default values
// Set maximum value for range inputs
rangeInputs[0].max = max;
rangeInputs[1].max = max;
rangeInputs[2].max = max;
rangeInputs[3].max = max;

rangeInputs[0].value = min;
rangeInputs[1].value = max;
rangeInputs[2].value = min;
rangeInputs[3].value = max;

// Set initial values for price inputs and range inputs
priceInputs[0].value = min;
priceInputs[1].value = max;
priceInputs[2].value = min;
priceInputs[3].value = max;

// Update range slider positions based on default values
rangeValue[0].style.left = `${(min / rangeInputs[0].max) * 100}%`;
rangeValue[0].style.right = `${100 - (max / rangeInputs[1].max) * 100}%`;

rangeValue[1].style.left = `${(min / rangeInputs[0].max) * 100}%`;
rangeValue[1].style.right = `${100 - (max / rangeInputs[1].max) * 100}%`;

[priceInputs[0], priceInputs[1]].forEach((input, index) =>
  input.addEventListener("input", (e) => {
    let minp = parseInt(priceInputs[0].value);
    let maxp = parseInt(priceInputs[1].value);
    let diff = maxp - minp;

    // Error Logic
    if (minp < 0) {
      console.log("minimum price cannot be less than 0");
      priceInputs[0].value = 0;
      minp = 0;
    }

    // Validate the input values
    if (maxp > max) {
      console.log(`maximum price cannot be greater than ${max}`);
      priceInputs[1].value = max;
      maxp = max;
    }

    if (minp > maxp - priceGap) {
      console.log("price gap is too small");
      priceInputs[0].value = maxp - priceGap;
      minp = maxp - priceGap;

      if (minp < 0) {
        priceInputs[0].value = 0;
        minp = 0;
      }
    }

    // Check if the price gap is met
    // and max price is within the range
    if (diff >= priceGap && maxp <= rangeInputs[1].max) {
      if (e.target.className === "min-input") {
        rangeInputs[0].value = minp;
        let value1 = rangeInputs[0].max;
        rangeValue[0].style.left = `${(minp / value1) * 100}%`;
      } else {
        rangeInputs[1].value = maxp;
        let value2 = rangeInputs[1].max;
        rangeValue[0].style.right = `${100 - (maxp / value2) * 100}%`;
      }
    }
  })
);

[priceInputs[2], priceInputs[3]].forEach((input, index) =>
  input.addEventListener("input", (e) => {
    let minp = parseInt(priceInputs[2].value);
    let maxp = parseInt(priceInputs[3].value);
    let diff = maxp - minp;

    // Error Logic
    if (minp < 0) {
      console.log("minimum price cannot be less than 0");
      priceInputs[2].value = 0;
      minp = 0;
    }

    // Validate the input values
    if (maxp > max) {
      console.log(`maximum price cannot be greater than ${max}`);
      priceInputs[1].value = max;
      maxp = max;
    }

    if (minp > maxp - priceGap) {
      console.log("price gap is too small");
      priceInputs[2].value = maxp - priceGap;
      minp = maxp - priceGap;

      if (minp < 0) {
        priceInputs[2].value = 0;
        minp = 0;
      }
    }

    // Check if the price gap is met
    // and max price is within the range
    if (diff >= priceGap && maxp <= rangeInputs[3].max) {
      if (e.target.className === "min-input") {
        rangeInputs[2].value = minp;
        let value1 = rangeInputs[2].max;
        rangeValue[2].style.left = `${(minp / value1) * 100}%`;
      } else {
        rangeInputs[3].value = maxp;
        let value2 = rangeInputs[3].max;
        rangeValue[2].style.right = `${100 - (maxp / value2) * 100}%`;
      }
    }
  })
);

[rangeInputs[0], rangeInputs[1]].forEach((input, index) => {
  input.addEventListener("input", (e) => {
    let minVal = parseInt(rangeInputs[0].value);
    let maxVal = parseInt(rangeInputs[1].value);

    let diff = maxVal - minVal;

    // Check if the price gap is exceeded
    if (diff < priceGap) {
      // Check if the input is the min range input
      if (e.target.className === "min-range") {
        rangeInputs[0].value = maxVal - priceGap;
      } else {
        rangeInputs[1].value = minVal + priceGap;
      }
    } else {
      // Update price inputs and range progress
      priceInputs[0].value = minVal;
      priceInputs[1].value = maxVal;

      rangeValue[0].style.left = `${(minVal / rangeInputs[0].max) * 100}%`;
      rangeValue[0].style.right = `${
        100 - (maxVal / rangeInputs[1].max) * 100
      }%`;
    }
  });
});

[rangeInputs[2], rangeInputs[3]].forEach((input, index) => {
  input.addEventListener("input", (e) => {
    let minVal = parseInt(rangeInputs[2].value);
    let maxVal = parseInt(rangeInputs[3].value);

    let diff = maxVal - minVal;

    // Check if the price gap is exceeded
    if (diff < priceGap) {
      // Check if the input is the min range input
      if (e.target.className === "min-range") {
        rangeInputs[2].value = maxVal - priceGap;
      } else {
        rangeInputs[3].value = minVal + priceGap;
      }
    } else {
      // Update price inputs and range progress
      priceInputs[2].value = minVal;
      priceInputs[3].value = maxVal;

      rangeValue[1].style.left = `${(minVal / rangeInputs[0].max) * 100}%`;
      rangeValue[1].style.right = `${
        100 - (maxVal / rangeInputs[1].max) * 100
      }%`;
    }
  });
});

//! end of Price Range Slider

//? Mobile Filter Logic
/**
 * Mobile Filter Menu
 * @description Mobile Filter Menu UI. This is a class that handles the mobile filter menu and is constructed via elements and collection data.
 */
class MobileFilterMenu {
  constructor(collection = [], collectionInfo, collectionFilters) {
    this.collection = collection;
    this.collectionFilters = collectionFilters;
    this.collectionInfo = collectionInfo;
    this.body = document.querySelector("body");
    this.html = document.querySelector("html");
    this.menu = document.querySelector("#Filter-Mobile__Menu-Wrapper");
    this.openBtn = document.querySelector(
      'button[data-element="Filter-Mobile__Btn"]'
    );
    this.closeBtn = document.querySelector(
      'button[data-element="Filter-Mobile__CloseBtn"]'
    );
    this.#attachEvents();
  }

  #attachEvents() {
    this.openBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      this.toggleMenu("open");
    });
    this.closeBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      this.toggleMenu("close");
    });
  }

  toggleMenu(state) {
    if (state === "open") {
      this.body.style.overflow = "hidden";
      this.html.style.overflow = "hidden";
      this.menu.style.visibility = "visible";
    }

    if (state === "close") {
      this.body.style.overflow = "";
      this.html.style.overflow = "";
      this.menu.style.visibility = "hidden";
    }
  }
}

new MobileFilterMenu(collection, collectionMetaInfo);
